<script setup lang="ts">
const { count, totalPrice } = useCart();
const { count: wishlistCount } = useWishlist();
const localePath = useLocalePath();
const { formatLink } = useInternationalization(localePath);

const miniCartModal = useMiniCartModal();
const openSearchMenu = ref(false);
const showMenu = ref(false);
const makeSticky = ref(false);

const onScroll = () => {
  makeSticky.value = window.scrollY > 200;
};

onMounted(() => {
  window.addEventListener("scroll", onScroll);
});
</script>

<template>
  <header class="header relative" :class="{ sticky: makeSticky }">
    <div class="top-header">
      <div class="container">
        <div class="top-header-in bg-cust_cream py-2">
          <ul class="flex flex-wrap justify-around text-sm md:text-base">
            <li>{{ $t("plubel.header.freeShipping") }}</li>
            <li class="hidden sm:block">
              {{ $t("plubel.header.deliveryIn") }}
            </li>
            <li class="hidden md:block">
              {{ $t("plubel.header.securePayment") }}
            </li>
            <li class="hidden lg:block">
              {{ $t("plubel.header.returnPolicy") }}
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="headermain pt-5 pb-12 lg:py-8 xl:pt-10 xl:pb-12">
      <div class="container relative">
        <div class="w-full flex justify-between items-center">
          <div>
            <NuxtLink :to="formatLink(`/`)" class="text-[0px]">
              <img
                src="assets/images/logo.svg"
                alt="logo of the shop"
                class="w-[97px] md:w-[120px] lg:w-[158px]"
              />
            </NuxtLink>
          </div>
          <div class="main-menu z-10" :class="{ block: showMenu }">
            <div class="lg:hidden max-w-[600px] m-auto">
              <div class="mb-12 flex items-center justify-between">
                <h3 class="mb-0">{{ $t("plubel.header.menu") }}</h3>
                <div
                  class="close-menu w-10 -me-2 text-center text-2xl"
                  @click="showMenu = false"
                >
                  <i class="fa-solid fa-xmark"></i>
                </div>
              </div>
              <!-- <div class="mb-12 flex flex-col gap-4">
                <LanguageSwitcher view="mobile" />
              </div> -->
              <h4 class="mb-2">{{ $t("plubel.header.category") }}</h4>
            </div>

            <LayoutTopNavigation @close-menu="showMenu = false" />
          </div>
          <div class="flex gap-2 md:gap-1">
            <div
              class="menu-open flex items-center justify-center lg:hidden w-8 h-8 md:w-10 md:h-10 text-xl"
              @click="showMenu = !showMenu"
            >
              <img src="/assets/images/bars.svg" alt="bars" />
            </div>

            <a
              href="#"
              class="w-8 h-8 md:w-10 md:h-10 flex items-center justify-center"
              @click="openSearchMenu = !openSearchMenu"
            >
              <img src="/assets/images/search.svg" alt="search" />
            </a>

            <NuxtLink
              class="w-8 h-8 md:w-10 md:h-10 flex items-center justify-center md:bg-cust_green rounded-lg md:text-white hover:lg:text-white hover:lg:opacity-90 relative"
              aria-label="wishlist"
              data-testid="wishlist-button"
              :to="formatLink(`/wishlist`)"
            >
              <img
                class="md:hidden h-5 w-5"
                src="/assets/images/heart-black.svg"
                alt="heart"
              />
              <img
                class="hidden md:block"
                src="/assets/images/heart-white.svg"
                alt="heart"
              />
              <ClientOnly>
                <span
                  v-if="wishlistCount"
                  class="absolute text-xs bg-cust_green text-white md:text-cust_green md:bg-white rounded-full h-[16px] w-[16px] top-[2px] right-[2px] text-center"
                >
                  {{ wishlistCount }}
                </span>
              </ClientOnly>
            </NuxtLink>

            <!-- <LanguageSwitcher view="desktop" /> -->

            <AccountMenu />
            <button
              class="flex items-center justify-center md:justify-start h-8 w-8 md:w-auto md:h-10 gap-2 md:px-3 bg-cust_cream rounded-lg cartBtnHead relative"
              aria-label="Mini cart"
              data-testid="cart-button"
              @click="miniCartModal.open"
            >
              <img src="/assets/images/cart.svg" alt="cart" />

              <span
                class="amount whitespace-nowrap hidden xl:block text-lg font-normal"
                v-if="count > 0"
              >
                <SharedPrice
                  :value="totalPrice"
                  class="text-secondary-600 font-normal"
                  data-testid="order-item-promotion-totalprice"
                >
                  <template #afterPrice>*</template>
                </SharedPrice>
              </span>

              <span
                class="w-5 h-5 rounded-full font-semibold text-[10px] border-cust_green bg-cust_green text-white font-inter flex items-center justify-center absolute right-[-10px] -top-[7px] block xl:hidden"
                v-if="count > 0"
              >
                {{ count }}</span
              >
            </button>
          </div>
        </div>
        <div class="desktop-menu"></div>
        <LayoutStoreSearch
          v-if="openSearchMenu"
          @link-clicked="openSearchMenu = false"
        />
      </div>
    </div>

    <div class="flex items-center justify-end">
      <CheckoutSideCart :controller="miniCartModal" />
    </div>
  </header>
</template>
